<div class="container">
    <div class="header">
        <ng-content select="[header]"></ng-content>
    </div>
    <div class="content">
        <ng-content></ng-content>
    </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/module/module.component.html